import { generateAutomationName } from "../../helpers/generateAutomationName";

export const sharedAutomationKeys = {
    chartContainer: generateAutomationName("widget", ["body", "chart", "container"]),
    chartLoader: generateAutomationName("widget", ["body", "chart", "loader"]),
    tableContainer: generateAutomationName("widget", ["body", "table", "container"]),
    tableLoader: generateAutomationName("widget", ["body", "table", "loader"]),
    changeContainer: generateAutomationName("widget", ["body", "change", "container"]),
};
